import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The finn hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a bright nautical palette pulled from his painted
 * art: a warm coral-red brand, deep-navy secondary, and treasure-gold accent, over a sunlit ocean-dawn canvas
 * and a deep-navy sea-and-sky dusk (his own world). Choosing him recolours the WHOLE kid shell: the brand ramp
 * drives buttons / meters / rings in coral, the canvas warms to a seaside dawn, and the hero stage takes his
 * navy dusk. Every brand colour is paired with its own foreground for legibility.
 *
 * Palette: navy #2b3a67 · red #e8563f · gold #ffce57.
 */
export const finnTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — coral red. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light text
  // (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #DB351A for coloured shadows.
  '--color-primary': '#DB351A',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#EF6A52',
  '--color-primary-deep': '#A5311F',
  '--color-primary-tint': '#FCE1DA',
  '--color-primary-glow-rgb': '219 53 26',
  '--color-secondary': '#2B3A67',
  '--color-secondary-fg': '#FFFFFF',
  '--color-accent': '#FFCE57',
  '--color-accent-fg': '#4A3800',
  // CANVAS — a coral bloom top-left, a warm-gold bloom bottom-right (a sunlit seaside dawn behind the content).
  '--canvas-a': '#FCE3DC',
  '--canvas-b': '#FDF1D5',
  // A deep-navy sea-and-sky dusk fading to a warm golden horizon (white text stays AA over it).
  '--sky-top': '#1c2747',
  '--sky-mid': '#2b3a67',
  '--sky-low': '#5f7bb0',
  '--sky-glow': '#ffce57',
  '--sky-fg': '#ffffff',
});
